<template>
  <div
    id="confirmation"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="confirmationLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="confirmationLabel" class="modal-title">Confirm delete</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          {{ message }}
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            data-dismiss="modal"
            :loading="loading"
            @click="onConfirm"
          >
            Yes
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            No
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Confirmation",
  props: {
    onConfirm: {
      type: Function,
      required: true,
    },
    message: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
